import { useTranslation } from "react-i18next";

// Extracted from SellPanelsPage.jsx's numbered process list so it can be
// reused on other pages (e.g. CorporatePartnersPage) without duplicating it.
//
// `stepLabel` is optional — SellPanelsPage doesn't pass it, so it keeps
// using the translated "Step {number}" copy exactly as before. Pages with
// English-only content can pass a plain string instead (see StatCounter's
// `highlight` / ComplianceBadge's `validUntilLabel` for the same pattern).
const ProcessStep = ({ number, icon: Icon, title, description, stepLabel }) => {
  const { t } = useTranslation();
  return (
    <div className="relative flex gap-6">
      <div className="relative">
        <div className="w-12 h-12 bg-navy text-gold flex items-center justify-center rounded-sm z-10 relative">
          <Icon size={24} strokeWidth={1.5} />
        </div>
        <div className="step-line" />
      </div>
      <div className="flex-1 pb-12">
        <span className="text-gold text-xs uppercase tracking-wider font-semibold">
          {stepLabel || t("sellPanels.process.stepLabel", { number })}
        </span>
        <h3 className="font-outfit text-xl font-semibold text-navy mt-1 mb-2">
          {title}
        </h3>
        <p className="text-slate-600 leading-relaxed">{description}</p>
      </div>
    </div>
  );
};

export default ProcessStep;
